import { Button, IButtonProps } from "./Button";

export type { IButtonProps };
export default Button;
